





















































































import {
  Component,
  mixins,
  Watch,
  namespace,
  Vue,
} from 'nuxt-property-decorator'
import {
  mdiClose,
  mdiMagnify,
  mdiBarcodeScan,
  mdiMapMarkerOutline,
  mdiGiftOutline,
} from '@mdi/js'
import vClickOutside from 'v-click-outside'
import { ISearchSuggest } from '~/assets/interfaces/search'
import { debounce } from '~/assets/functions/debounce'
import { PERSONAL_PATH, SEARCH_PATH } from '~/assets/config/path'
import { SEARCH_API } from '~/assets/config/api-path'
import MixinGeneral from '~/assets/mixins/general'
import { filterUrl } from '~/assets/filters/url'
import { ICity } from '~/assets/interfaces/location'
import { IUser } from '~/assets/interfaces/user'

Vue.use(vClickOutside)

const auth = namespace('auth')
const siteStore = namespace('site')

@Component({
  components: {
    ComponentIcon: () => import('~/components/icon/icon.vue'),
    ComponentFormButtonIcon: () => import('~/components/form/button-icon.vue'),
    ComponentFormInputText: () => import('~/components/form/input-text.vue'),
    ComponentFormSubmitHidden: () =>
      import('~/components/form/submit-hidden.vue'),
    componentHeaderQuickSearchSuggests: () =>
      import('~/components/search/quick-search-suggests.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentPopupPreloader: () => import('~/components/popup/preload.vue'),
    ComponentLocationCitySelection: () =>
      import('~/components/location/city-selection.vue'),
  },
  filters: {
    filterUrl,
  },
})
export default class ComponentMobileSearch extends mixins(MixinGeneral) {
  @auth.State('user') user!: IUser | null
  @siteStore.Getter('getLocationName') private locationName!: string | null
  @siteStore.Action('setLocation') private setLocation!: (
    city: ICity
  ) => Promise<void>

  private mdiMagnify = mdiMagnify
  private mdiClose = mdiClose
  private mdiBarcodeScan = mdiBarcodeScan
  private mdiMapMarkerOutline = mdiMapMarkerOutline
  private mdiGiftOutline = mdiGiftOutline
  private searchText = ''
  private suggestions: ISearchSuggest[] = []

  private isLoading = false

  private isOpenPopupLocation = false
  private isComponentCitySelectionLoaded = false

  private PERSONAL_PATH: string = PERSONAL_PATH

  @Watch('searchText')
  private searchTextHandler(query: string) {
    this.searchQuickDebounce(query, this)
  }

  @Watch('$route')
  private onRouteChange() {
    this.searchText = ''
    this.suggestions = []
    this.closeSearch()
  }

  private clearSearchText() {
    this.searchText = ''
  }

  private closeSearch() {
    this.clickOutside = true
  }

  private closeSearchClickHandler() {
    this.closeSearch()
    this.clearSearchText()
  }

  private clickInsideHandler() {
    this.clickOutside = false
  }

  private get isShowSuggest() {
    return this.suggestions.length > 0 && !this.clickOutside
  }

  private clickOutside = true
  private searchQuickDebounce: (query: string, that: this) => void = debounce(
    (query: string, that: this) => {
      that.getItems(query)
    },
    250
  )

  private async getItems(query: string) {
    if (query.trim().length > 0) {
      this.isLoading = true
      const response = await this.$axios.$get(SEARCH_API, {
        params: {
          query,
        },
      })
      this.suggestions = response.suggestions
      this.isLoading = false
    }
  }

  private submitHandler() {
    if (this.searchText.trim().length > 0) {
      this.$router.push({
        path: filterUrl(SEARCH_PATH),
        query: { query: this.searchText },
      })
    }
  }

  private get classSearchWrapper() {
    return {
      [this.$style.searchWrapper]: true,
      [this.$style.active]: !this.clickOutside,
    }
  }

  private get classForm() {
    return {
      [this.$style.form]: true,
      [this.$style.active]: !this.clickOutside,
    }
  }

  private async barcodeScan() {
    if (!this.isNativePlatform) return

    const { CapacitorBarcodeScanner } = await import(
      '@capacitor/barcode-scanner'
    )

    try {
      const result = await CapacitorBarcodeScanner.scanBarcode({
        hint: 17, // 'ALL', можно заменить на enum если импортируете
        scanInstructions: 'Наведите камеру на штрихкод',
      })

      const scanned = result?.ScanResult?.trim()

      if (scanned) {
        this.searchText = scanned
        this.submitHandler()
      }
    } catch {}
  }

  private async locationSelect(location: ICity) {
    await this.setLocation(location)
    this.isOpenPopupLocation = false
  }
}
